import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import { ParcMaintenanceCheckboxListComponent} from './components/parc-maintenance-checkbox-list.component';
import { ParcTechnologieCheckboxListComponent} from './components/parc-technologie-checkbox-list.component';
import { TypeAccesCheckboxListComponent} from './components/type-acces-checkbox-list.component';

import { StaticTypeService } from './services/static-types.service';

import { CheckboxListModule } from '../shared/checkbox-list/checkbox-list.module';
import { MemoCategoryCheckboxListComponent } from './components/memo-category-checkbox-list.component';

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
		CheckboxListModule
	],
	providers: [
		StaticTypeService,
	],
	declarations: [
		MemoCategoryCheckboxListComponent,
	    ParcMaintenanceCheckboxListComponent,
	    ParcTechnologieCheckboxListComponent,
	    TypeAccesCheckboxListComponent,
	],
	exports: [
		MemoCategoryCheckboxListComponent,
	    ParcMaintenanceCheckboxListComponent,
	    ParcTechnologieCheckboxListComponent,
	    TypeAccesCheckboxListComponent,
	]
})
export class StaticTypesModule { }